import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import useAuth from "../common/header/useAuth";
import { Container, Navbar, Image } from "react-bootstrap";

const BidHeader = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);

  const { userName } = useAuth();

  //   const userName = localStorage.getItem("userName");
  return (
    <Navbar bg="light" expand="lg" className="py-2">
      <Container>
        <Navbar.Brand>
          <Image
            src="/assets/images/hubzu-logo.png"
            alt="hubzu-logo"
            className="cursor-pointer"
            style={{ maxWidth: "150px", height: "auto" }}
            onClick={() => navigate("/")}
          />
        </Navbar.Brand>

        <Navbar.Text className="ms-auto user_bid-info">{userName}</Navbar.Text>
      </Container>
    </Navbar>
  );
};

export default BidHeader;
